import { render, staticRenderFns } from "./BtnMostrarRateios.vue?vue&type=template&id=1fc35a18"
import script from "./BtnMostrarRateios.vue?vue&type=script&lang=js"
export * from "./BtnMostrarRateios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports